import type { ApiError } from "@/types/common.types";

export const FORM_NAME_TAKEN = "FORM_NAME_TAKEN";

export const isFormNameTaken = (error: unknown) =>
  (error as ApiError | undefined)?.response?.data?.error?.code === FORM_NAME_TAKEN;

export const formNameTakenMessage = (name: string) => `A form named "${name}" already exists.`;

// Used when the API reports the clash without a message of its own.
export const FORM_NAME_TAKEN_FALLBACK_MESSAGE = "A form with this name already exists.";
